import * as React from 'react';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkPriceLockup, UitkPriceLockupAlign } from 'uitk-react-price-lockup';

import { SelectAction } from 'components/search/listings/offer';
import { FlightAction, FlightsBargainFareOffer, FlightsStandardOffer } from '__generated__/api';

interface DetailsAndFaresFooterProps {
  openForcedChoiceModal?: boolean;
  onApplySelect?: (identifier: string) => void;
  handleOfferSelect?: (
    selectOfferAction: FlightAction.Fragment,
    isSmallViewport: boolean,
    availableFaresInformation?:
      | FlightsStandardOffer.FlightsJourneyAvailableFaresInformation
      | FlightsBargainFareOffer.FlightsJourneyAvailableFaresInformation
  ) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  availableFaresInformation: any;
  isSmallViewport: boolean;
}

export const DetailsAndFaresFooter = ({
  openForcedChoiceModal,
  onApplySelect,
  handleOfferSelect,
  availableFaresInformation,
  isSmallViewport
}: DetailsAndFaresFooterProps) => {
  const fareTypes =
    availableFaresInformation.fareChoiceInformation && availableFaresInformation.fareChoiceInformation.fareTypes
      ? availableFaresInformation.fareChoiceInformation.fareTypes
      : null;
  const selectedFareType = fareTypes ? fareTypes.find(fare => fare.selected) : null;
  const { chooseFareAction } = selectedFareType || {};
  const { stepIndicator } = chooseFareAction || {};
  const { journeyContinuationId } = stepIndicator || {};

  const selectOfferClickHandler = () => {
    handleOfferSelect(
      selectedFareType ? selectedFareType.chooseFareAction : null,
      isSmallViewport,
      availableFaresInformation
    );
  };

  return selectedFareType ? (
    <UitkLayoutFlex
      className="all-x-padding-six s-y-padding-one all-y-margin-three all-y-padding-two"
      justifyContent="space-between"
      data-test-id="details-and-fares-footer"
    >
      <UitkLayoutFlexItem className="all-x-margin-one">
        <UitkPriceLockup
          align={UitkPriceLockupAlign.LEFT}
          lockupPrice={selectedFareType.formattedPrice.completeText}
          priceSubtextFirst={availableFaresInformation.fareChoiceInformation.tripTypePerTraveler}
          a11yPrice={selectedFareType.formattedPrice.completeText}
          priceSubtextBold={selectedFareType.totalPrice}
        />
      </UitkLayoutFlexItem>
      <UitkLayoutFlexItem>
        <SelectAction
          displayAction={selectedFareType.chooseFareAction.displayAction}
          url={selectedFareType.chooseFareAction.relativeURI}
          isDisabled={false}
          onOfferSelect={selectOfferClickHandler}
          journeyContinuationId={journeyContinuationId}
          analytics={selectedFareType.chooseFareAction.analyticsList}
          flightsActionType={selectedFareType.chooseFareAction.type}
          openUrlInNewTab={!openForcedChoiceModal}
          onApplySelect={onApplySelect}
          identifier={selectedFareType.identifier}
          journeySearchCriteria={selectedFareType.chooseFareAction.journeySearchCriteria}
        />
      </UitkLayoutFlexItem>
    </UitkLayoutFlex>
  ) : (
    <UitkLayoutFlex
      className="all-x-padding-six s-y-padding-one all-y-margin-three all-y-padding-two"
      justifyContent="space-between"
      data-test-id="bargain-details-and-fares-footer"
    >
      {availableFaresInformation.flightsJourneySummary && (
        <UitkLayoutFlexItem className="all-x-margin-one">
          <UitkPriceLockup
            align={UitkPriceLockupAlign.LEFT}
            lockupPrice={availableFaresInformation.flightsJourneySummary.formattedPrice.completeText}
            priceSubtextFirst={availableFaresInformation.flightsJourneySummary.tripTypePerTraveler}
            a11yPrice={availableFaresInformation.flightsJourneySummary.formattedPrice.completeText}
            priceSubtextBold={availableFaresInformation.flightsJourneySummary.totalPrice}
          />
        </UitkLayoutFlexItem>
      )}
      {availableFaresInformation.applySelection && (
        <UitkLayoutFlexItem>
          <SelectAction
            displayAction={availableFaresInformation.applySelection.displayAction}
            url={availableFaresInformation.applySelection.relativeURI}
            isDisabled={false}
            onOfferSelect={selectOfferClickHandler}
            analytics={availableFaresInformation.applySelection.analyticsList}
            flightsActionType={availableFaresInformation.applySelection.type}
            openUrlInNewTab={!openForcedChoiceModal}
            accessibilityMessage={availableFaresInformation.applySelection.accessibilityMessage}
            onApplySelect={onApplySelect}
            identifier={null}
            journeySearchCriteria={availableFaresInformation.applySelection.journeySearchCriteria}
          />
        </UitkLayoutFlexItem>
      )}
    </UitkLayoutFlex>
  );
};
